import BossModel from "@/models/BossModel";
import Region from '@/models/Region/Region';
import City from "@/models/City/City";
import Country from "@/models/Country/Country";
import Product from "@/models/Product/Product";

export default class ProductAddress extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'product/address';

    /**
     *
     * @type {string}
     */
    static entity = 'productAddresses';

    static fields() {
		return {
			id: this.number(null).nullable(),
			region_id: this.number(null).nullable(),
			product_id: this.number(null).nullable(),
			city_name: this.attr(null),
			city_id: this.number(null).nullable(),
			country_id: this.number(null).nullable(),
			street: this.attr(null),
			number: this.attr(null),
			zip_code: this.attr(null),
			telephone: this.attr(null),
			fax: this.attr(null),
			email: this.attr(null),
			website: this.attr(null),
			is_active: this.boolean(null),
			sort_order: this.number(null).nullable(),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			deleted_at: this.attr(null),
            region: this.belongsTo(Region, 'region_id'),
            city: this.belongsTo(City, 'city_id'),
            country: this.belongsTo(Country, 'country_id'),
            product: this.belongsTo(Product, 'product_id'),
		}
	}

    /**
     *
     * @returns {boolean|*}
     */
    Region(){
        return this.getRelated('region');
    }
}
